export default {
  title: `Notifications`,
  new: `New: {count}`,
  empty: `No notifications to show`,
  archive: `Notifications archive`,
  markAllAsSeen: `Mark all as seen`,
  newNotifications: `New notifications`,
};
